import { i18n } from "@dehub/theme"

/**
 * Backend error → readable text. BE throws i18n keys (`error.<domain>.<name>`); some route errors carry
 * ids after a colon (`error.route.dn_not_routable:<id,id>`), so the part before `:` is the key. A key
 * missing from `errors.json` falls back to `fallbackKey` (also an errors key), never the raw key.
 */
export function translateBackendError(err: unknown, fallbackKey = "error.common.unknown"): string {
  const raw = typeof err === "string" ? err : (err as { message?: string } | null)?.message ?? ""
  const key = raw.startsWith("error.") || raw.startsWith("system.") ? raw.split(":")[0] : null
  if (key) {
    const translated = i18n.t(key, { ns: "errors", defaultValue: "" })
    if (typeof translated === "string" && translated.length > 0) return translated
  } else if (raw) {
    return raw
  }
  const fallback = i18n.t(fallbackKey, { ns: "errors", defaultValue: "" })
  return typeof fallback === "string" && fallback.length > 0 ? fallback : i18n.t("common:messages.error")
}
